import React, { useState } from "react";
import Reports from "../components/Programs/Reports";
import Aside from "../modules/SideNav/Aside";

function ReportsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <Reports handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default ReportsLayout;
